import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../common/header";
import NavigationBar from "../common/navbar";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function EditSubMenu() {
  const { id } = useParams();
  const navigate = useNavigate();
  const navigateToMenus = () => {
    navigate("/project/menus/submenus/" + localStorage.getItem("menu_id"));
  };
  let [loading, setLoading] = useState(true);
  let [menu, setMenu] = useState({ name: "", description: "" });

  const handleChange = (prop) => (event) => {
    const { name, value } = event.target;
    setMenu({ ...menu, [prop]: event.target.value });
  };

  useEffect(() => {
    getProjectMenuDetails(id);
    setMenu({ name: "", description: "" });
    setLoading(false);
  }, []);

  // Get Project Menu Details
  const getProjectMenuDetails = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/submenu/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization:
            "Bearer " +
            JSON.parse(localStorage.getItem("user_info")).accessToken,
        },
      })
      .then((response) => {
        setMenu({
          name: response.data.name,
          description: response.data.description,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  // Add Project Menu Details
  const EditProjectSubMenu = async() => {
    setLoading(true);
    let result = await fetch(`${process.env.REACT_APP_API_URL}/submenu/`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization:
            "Bearer " +
            JSON.parse(localStorage.getItem("user_info")).accessToken,
        },
        body:JSON.stringify({
          id: id,
          name: menu.name,
          description: menu.description,
          projectId: localStorage.getItem("project_id"),
          menuId: localStorage.getItem("menu_id"),
        }),
      }
    );
    
    if (result.status==200) {   
      navigate("/project/menus/submenus/" + localStorage.getItem("menu_id"));
    } 
    else if(result.status==400){
      alert("Bad request")
      }
    else{
      localStorage.clear("user_info");
      navigate("/");
    }
 
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <NavigationBar />
        <div className="col-md-9">
          <Header />
          <h2>Edit SubMenu</h2>
          <hr />

          <div className="row">
            <div className="col-md-9">
              <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/organizations">Organizations</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <Link
                      to={
                        "/projects/" + localStorage.getItem("organization_id")
                      }
                    >
                      Projects
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link
                      to={
                        "/project/" +
                        localStorage.getItem("project_id") +
                        "/menus"
                      }
                    >
                      Menus
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Submenu</li>
                </ol>
              </nav>
            </div>
          </div>
          <hr />

          <form role="form">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={menu.name}
                    onChange={handleChange("name")}
                    onBlur={handleChange("name")}
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    id="description"
                    aria-rowspan={3}
                    value={menu.description}
                    onChange={handleChange("description")}
                    onBlur={handleChange("description")}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="row" style={{ marginBottom: "2rem" }}></div>

            <div className="row">
              <div className="col-md-3">
                <button
                  type="button"
                  className="btn btn-primary me-2"
                  onClick={EditProjectSubMenu}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={navigateToMenus}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditSubMenu;
